import RentState from '../../../models/store/modules/rent-state.model';

export const mutations = {
  rentStateIsReady(state: RentState, payload: boolean): void {
    state.rentStateIsReady = payload;
  },
};
